import { render, staticRenderFns } from "./TreatmentPlanObjectivesV1.vue?vue&type=template&id=5f46a82c&"
import script from "./TreatmentPlanObjectivesV1.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlanObjectivesV1.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlanObjectivesV1.vue?vue&type=style&index=0&id=5f46a82c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports